import { AnkiPracticeTests } from '@/components/anki-practice-tests/AnkiPracticeTests';
import React from 'react';

export default function _AnkiPracticeTests() {
  return <AnkiPracticeTests />;
}
